<template>
    <div class="row">
        <div class="section">
            <div class="container">
                <div class="slider">
                    <ul class="slides">
                        <li>
                            <img src="../../img/galeriaFotos/002.jpg"> <!-- random image -->
                        </li>
                        <li>
                            <img src="../../img/galeriaFotos/008.jpg"> <!-- random image -->
                        </li>
                        <li>
                            <img src="../../img/galeriaFotos/012.jpg"> <!-- random image -->
                        </li>
                        <li>
                            <img src="../../img/galeriaFotos/017.jpg"> <!-- random image -->
                        </li>
                        <li>
                            <img src="../../img/galeriaFotos/021.jpg"> <!-- random image -->
                        </li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col s12 m12 l12">
                        <div class="card z-depth-2 hoverable">
                            <div class="card-content">
                                <span class="card-title">Café da Manhã</span>
                                <p>Desfrute de um delicioso café da manhã especialmente preparado para você!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">

    export default {
        mounted(){
            $('nav div ul').children().removeClass('active');
            $('.nav-cafe').addClass('active');

            $('.slider').slider();
            $('.materialboxed').materialbox();
        }
    };
</script>


// WEBPACK FOOTER //
// cafe.vue?264c7126